/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Systemsettings_Languagebadge2Inputs */

const zh_systemsettings_languagebadge2 = /** @type {(inputs: Systemsettings_Languagebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`语言`)
};

const en_systemsettings_languagebadge2 = /** @type {(inputs: Systemsettings_Languagebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language`)
};

const es_systemsettings_languagebadge2 = /** @type {(inputs: Systemsettings_Languagebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idioma`)
};

/**
* | output |
* | --- |
* | "Language" |
*
* @param {Systemsettings_Languagebadge2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const systemsettings_languagebadge2 = /** @type {((inputs?: Systemsettings_Languagebadge2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Systemsettings_Languagebadge2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_systemsettings_languagebadge2(inputs)
	if (locale === "en") return en_systemsettings_languagebadge2(inputs)
	return es_systemsettings_languagebadge2(inputs)
});
export { systemsettings_languagebadge2 as "systemSettings_languageBadge" }